import React from "react";
import PageContentOverView from "./PageContentOverView";
import PageContentDetails from "./PageContentDetails";

const PageContent = ({
  selectedHeading,
  helpPageData,
  openSubheadingId,
  toggleSubheading,
  currPageContent,
  tertiaryId,
  setTertiaryId,
  loadPageContent,
  secondaryHeading,
  tertiarySubHeading,
  mainHeading,
  headingClicked,
  setCurrPageContent,
  setHeadingClicked,
  setIsSearchOpen,
  setSearchQuery,
  loading,
  onGoHome,
  onOpenSupport,
  onFeedback,
  isArticleView,
  isCategoryView,
  categorySlug,
}) => {
  if (isArticleView) {
    return (
      <PageContentDetails
        selectedHeading={selectedHeading}
        currPageContent={currPageContent}
        tertiaryId={tertiaryId}
        setTertiaryId={setTertiaryId}
        secondaryHeading={secondaryHeading}
        tertiarySubHeading={tertiarySubHeading}
        mainHeading={mainHeading}
        loadPageContent={loadPageContent}
        setCurrPageContent={setCurrPageContent}
        setHeadingClicked={setHeadingClicked}
        onGoHome={onGoHome}
        onOpenSupport={onOpenSupport}
        onFeedback={onFeedback}
      />
    );
  }

  return (
    <PageContentOverView
      selectedHeading={selectedHeading}
      helpPageData={helpPageData}
      toggleSubheading={toggleSubheading}
      openSubheadingId={openSubheadingId}
      tertiaryId={tertiaryId}
      setTertiaryId={setTertiaryId}
      headingClicked={headingClicked}
      setHeadingClicked={setHeadingClicked}
      setIsSearchOpen={setIsSearchOpen}
      setSearchQuery={setSearchQuery}
      loading={loading}
      isCategoryView={isCategoryView}
      categorySlug={categorySlug}
    />
  );
};

export default PageContent;
